import React from 'react';
import { withTranslation } from 'react-i18next';

class About4 extends React.Component {
    render() {
        const { t } = this.props;
        const items = [
            { title: t('pages.personalData.locations.item2.title'), description: t('pages.personalData.locations.item2.description') },
            { title: t('pages.personalData.locations.item3.title'), description: t('pages.personalData.locations.item3.description') },
        ];
        return (
            <>
                {/* Intro — visual minimalista (escudo) + texto principal */}
                <div className="dp-section dp-cream mobile-page-padding">
                    <div className="container">
                        <div className="dp-intro-grid">
                            <div className="dp-figure">
                                <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M32 7 L51 14 V30 C51 42 43 50 32 56 C21 50 13 42 13 30 V14 Z" />
                                    <path d="M24 31 l6 6 l11 -13" />
                                </svg>
                            </div>
                            <div className="dp-intro-content">
                                <p className="dp-eyebrow">{t('pages.personalData.banner.pagename')}</p>
                                <h2 className="dp-title">{t('pages.personalData.locations.item1.title')}</h2>
                                <div className="dp-rule" />
                                <p className="dp-text">{t('pages.personalData.locations.item1.description')}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Detalle — items 2 y 3 + accesos */}
                <div className="dp-section dp-white mobile-page-padding">
                    <div className="container">
                        <div className="dp-grid2">
                            {items.map((item, i) => (
                                <div className="dp-item" key={i}>
                                    <div className="dp-item-h">
                                        <span className="dp-item-num">{`0${i + 2}`}</span>
                                        <h4>{item.title}</h4>
                                    </div>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                        <div className="dp-actions dp-actions-center">
                            <a href="/declaracion-de-privacidad" className="dp-btn">
                                {t('pages.personalData.buttons.privacyStatement')}
                                <span className="arw">&rarr;</span>
                            </a>
                            <a href="/data-protection" className="dp-btn">
                                {t('pages.personalData.buttons.security')}
                                <span className="arw">&rarr;</span>
                            </a>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default withTranslation()(About4);
